var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"color":"#d10a3a","icon":""},nativeOn:{"click":function($event){_vm.isDeleteReportOpen = true}}},[_c('v-icon',{attrs:{"large":""}},[_vm._v(" mdi-trash-can-outline ")])],1),_c('DeleteReportDialog',{attrs:{"isOpen":_vm.isDeleteReportOpen},on:{"close":function($event){_vm.isDeleteReportOpen = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }